/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".components-wrapper[_ngcontent-%COMP%]{position:relative;margin-top:20px}.document-build-wrapper[_ngcontent-%COMP%]   .document[_ngcontent-%COMP%]{min-height:200px;margin-top:15px}.tools-items[_ngcontent-%COMP%]{z-index:2;position:absolute;top:60px;bottom:25px;left:35px;right:35px;overflow:hidden;margin:auto;border:1px solid #eee}.multifiles[_ngcontent-%COMP%]{margin-bottom:10px;padding:15px 20px}.remove-document-btn[_ngcontent-%COMP%]{position:absolute;right:0;min-width:40px;z-index:2;width:auto;padding:.3rem .2rem;top:-20px}"];
export { styles as styles };
